export default __webpack_public_path__ + "static/media/FASHION_HERALD.99d610ca.png";